import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/configuration/company'
const RESOURCE_NAME_POLICY = '/policy'

export default {
  edit(configdata) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, configdata)
  },
  getConfig() {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}`)
  },
  editPolicy(configdata) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_POLICY}`, configdata)
  },
  getPolicy() {
    return axios.get(`${config.webApiBase + RESOURCE_NAME_POLICY}`)
  },
}
